"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Tooltip/ClickTooltip.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);







var _common = require('web/components/Tooltip/common');







const createInitialState = () => ({
  isOpen: false,
  tooltipPosition: {},
  tooltipArrowPosition: {},
})

const ClickTooltip = (props) => {
  const {
    children, className,
    content = _common.DEFAULT_CONTENT,
    hideArrow = false,
    type = _common.DEFAULT_TYPE,
    place = _common.DEFAULT_PLACE,
    fixedPosition,
  } = props
  const [state, setState] = _react.useState.call(void 0, createInitialState)
  const { isOpen, tooltipPosition, tooltipArrowPosition } = state

  const { childRefs, cloneChildrenWithRefs } = _common.useChildRefs.call(void 0, )
  const targetRef = _react.useRef(null)
  const tooltipRef = _react.useRef(null)

  // The native listeners run after later renders; like the class reading
  // this.props and this.state, they read the latest committed values.
  const latestRef = _react.useRef.call(void 0, { fixedPosition, place, hideArrow, isOpen })
  _react.useLayoutEffect.call(void 0, () => {
    latestRef.current = { fixedPosition, place, hideArrow, isOpen }
  })

  _react.useLayoutEffect.call(void 0, () => {
    const toggleTooltip = (key) => {
      const latest = latestRef.current

      const nextTooltipPosition = latest.fixedPosition || _common.getTooltipPosition.call(void 0, 
        childRefs.current[key],
        tooltipRef.current,
        latest.place,
        latest.hideArrow,
      )

      const nextTooltipArrowPosition = _common.getToolTipArrowPosition.call(void 0, 
        // SAFETY: the container is mounted while its children's listeners are.
        targetRef.current ,
        nextTooltipPosition,
        latest.place,
      )

      setState({
        isOpen: !latest.isOpen,
        tooltipPosition: nextTooltipPosition,
        tooltipArrowPosition: nextTooltipArrowPosition,
      })
    }

    const handleClickAnywhere = () => setState(s => ({ ...s, isOpen: false }))

    // Listeners go on the children present at mount, as componentDidMount
    // did; the cleanup reads the refs at unmount, as componentWillUnmount did.
    const refs = childRefs.current
    const eventHandlers = {}
    Object.keys(refs).forEach(key => {
      eventHandlers[key] = e => {
        e.preventDefault()
        e.stopPropagation()
        toggleTooltip(key)
      }
      _optionalChain([refs, 'access', _ => _[key], 'optionalAccess', _2 => _2.addEventListener, 'call', _3 => _3('click', eventHandlers[key])])
    })
    window.addEventListener('click', handleClickAnywhere)

    return () => {
      Object.keys(refs).forEach(key => {
        const handler = eventHandlers[key]
        if (handler) _optionalChain([refs, 'access', _4 => _4[key], 'optionalAccess', _5 => _5.removeEventListener, 'call', _6 => _6('click', handler)])
      })
      window.removeEventListener('click', handleClickAnywhere)
    }
    // Runs on mount/unmount only: childRefs is a stable ref, and the
    // listeners read the latest values through refs.
  }, [childRefs])

  const containerClassName = _classBuilder2.default.call(void 0, 
    'blm-tooltip--container',
    className,
  )
  const tooltipClassName = _classBuilder2.default.call(void 0, 
    'blm-tooltip',
    'blm-tooltip--click',
    _common.getTooltipTypeClass.call(void 0, { type, place }),
    { hidden: !isOpen },
  )

  return (
    _react2.default.createElement('div', { ref: targetRef, className: containerClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
      , cloneChildrenWithRefs(children)
      , _react2.default.createElement('div', {
        className: tooltipClassName,
        style: tooltipPosition,
        ref: tooltipRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}

        ,  hideArrow
          ? null
          : _react2.default.createElement('div', { className: "blm-tooltip--arrow", style: tooltipArrowPosition, __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}})
        
        , content
      )
    )
  )
}

exports. default = ClickTooltip
